import { useMemo, useState } from 'react';
import { Image } from 'antd';
import { ImagePreviewCompare } from '@/components/ImagePreviewCompare';
import { FiledNameByBodyPart } from '@/pages/service/body-measurement/measurement-content/enumData';
import EmptyBox from '../EmptyBox';

import cx from './index.module.scss';

interface Props {
  serviceDetail: GetServiceOrderDetailResponse;
  measurementData?: GetMeasurementResultResponse;
}

const arrayHasValues = arr => {
  return arr?.some(item => !!item?.afterVal || !!item?.beforeVal);
};

const RFEffectRecord: React.FC<Props> = ({ serviceDetail, measurementData }) => {
  const onlyManual = useMemo(() => serviceDetail?.onlyManual, [serviceDetail]);
  const [previewIndex, setPreviewIndex] = useState<number>(0);

  const measurementDataList = useMemo(() => {
    return FiledNameByBodyPart?.[serviceDetail?.bodyPart]?.map(item => {
      return {
        name: item?.imageFiledName,
        beforeVal: measurementData?.before?.[item?.imageFiledName],
        afterVal: measurementData?.after?.[item?.imageFiledName],
      };
    }, []);
  }, [measurementData?.after, measurementData?.before, serviceDetail?.bodyPart]);

  return (
    <div className={cx('wrapper')}>
      {!arrayHasValues(measurementDataList) || (measurementData?.after === null && measurementData?.before === null) ? (
        <EmptyBox />
      ) : onlyManual ? (
        <div className={cx({ 'no-manual-wrapper': !onlyManual }, { 'manual-wrapper': onlyManual })}>
          <ImagePreviewCompare
            beforeImgList={measurementDataList?.map(item => item.beforeVal) || []}
            afterImgList={measurementDataList?.map(item => item?.afterVal) || []}
            previewIndex={previewIndex}
            updatePreviewIndex={setPreviewIndex}
            isNeedImgGroup={true}
            noBeforeUploadText="服务前围度测量未上传"
            noAfterUploadText="服务后围度测量未上传"
            source="no-servicing"
            totalCompareLength={measurementDataList?.length}
          >
            {measurementDataList?.map((item, index) => {
              return (
                <div key={item.name} className={cx('item')}>
                  <div className={cx('box', { 'empty-data': !item?.beforeVal })}>
                    {item?.beforeVal ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={item?.beforeVal}
                        />

                        <div className={cx('tag', 'before')}>服务前</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务前</div>
                        <div className={cx('empty-text', 'bottom-text')}>围度测量图片未上传</div>
                      </>
                    )}
                  </div>
                  <div className={cx('box', { 'empty-data': !item?.afterVal })}>
                    {item?.afterVal ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={item?.afterVal}
                        />

                        <div className={cx('tag', 'after')}>服务后</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务后</div>
                        <div className={cx('empty-text', 'bottom-text')}>围度测量图片未上传</div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </ImagePreviewCompare>
        </div>
      ) : (
        <div className={cx('no-manual-wrapper')}>
          <ImagePreviewCompare
            beforeImgList={measurementDataList?.map(item => item.beforeVal) || []}
            afterImgList={measurementDataList?.map(item => item?.afterVal) || []}
            previewIndex={previewIndex}
            updatePreviewIndex={setPreviewIndex}
            isNeedImgGroup={true}
            noBeforeUploadText="服务前围度测量未上传"
            noAfterUploadText="服务后围度测量未上传"
            source="no-servicing"
            totalCompareLength={measurementDataList?.length}
          >
            {measurementDataList?.map((item, index) => {
              return (
                <div key={item.name} className={cx('item')}>
                  <div className={cx('box', { 'empty-data': !item?.beforeVal })}>
                    {item?.beforeVal ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={item?.beforeVal}
                        />

                        <div className={cx('tag', 'before')}>服务前</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务前</div>
                        <div className={cx('empty-text', 'bottom-text')}>围度测量图片未上传</div>
                      </>
                    )}
                  </div>
                  <div className={cx('box', { 'empty-data': !item?.afterVal })}>
                    {item?.afterVal ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={item?.afterVal}
                        />

                        <div className={cx('tag', 'after')}>服务后</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务后</div>
                        <div className={cx('empty-text', 'bottom-text')}>围度测量图片未上传</div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </ImagePreviewCompare>
        </div>
      )}
    </div>
  );
};

export default RFEffectRecord;
